import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import {
  mockAssignedDomainsResponse,
  mockDomainAssigneesResponse,
  mockDomainsResponse,
  mockEffectiveRolesResponse
} from '@percent/domain/iam'

export const permissionHandlers = [
  rest.get(`${config.urls.api}v1/admin/authorisation/permissions`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: [] }))
  }),
  rest.get(`${config.urls.api}v1/admin/authorisation/domains`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockDomainsResponse }))
  }),
  rest.get(
    `${config.urls.api}v1/admin/authorisation/domains/accounts/:accountId/assigned-domains`,
    async (_, res, ctx) => {
      return res(ctx.status(200), ctx.json({ data: mockAssignedDomainsResponse }))
    }
  ),
  rest.get(`${config.urls.api}v1/admin/authorisation/:subject/:id/effective-roles`, async (_, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({ data: mockEffectiveRolesResponse, object: 'effective_authorisation_domain' })
    )
  }),
  rest.get(`${config.urls.api}v1/admin/authorisation/domains/:domainId/assignees`, async (_, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        data: mockDomainAssigneesResponse,
        object: 'authorisation_domain_assignee',
        pageSize: 25,
        _links: { current: `${config.urls.api}v1/admin/authorisation/domains/donations/assignees` }
      })
    )
  }),
  rest.put(`${config.urls.api}v1/admin/authorisation/domains/:domainId/assignees/:accountId`, async (_, res, ctx) => {
    return res(ctx.status(200))
  }),
  rest.delete(
    `${config.urls.api}v1/admin/authorisation/domains/:domainId/assignees/:accountId`,
    async (_, res, ctx) => {
      return res(ctx.status(200))
    }
  )
]
